import * as React from "react";

import { AuthenticationContext } from "./context";

export function useAuthentication() {
  return React.useContext(AuthenticationContext);
}
